import { Outlet } from 'react-router-dom';
import CardsPage from '../pages/CardsPage';

/** Two-pane My Payment Cards shell — the card list on the left, the selected
 *  card's detail (or editor) on the right. Mirrors ContactsLayout so the two
 *  surfaces feel identical. */
export default function CardsLayout(): JSX.Element {
  return (
    <div className="flex h-full flex-col">
      <div className="flex flex-1 min-h-0">
        <div className="w-[340px] flex-shrink-0 border-r border-hbs-border bg-hbs-bg overflow-y-auto">
          <CardsPage />
        </div>
        <div className="flex-1 overflow-y-auto bg-hbs-bg">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
